import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { AccuracyPage } from "@/pages/AccuracyPage";
import { BacktestPage } from "@/pages/BacktestPage";

export function MlPage({ refreshKey }) {
  return (
    <div className="fade-up">
      <h1 className="font-display text-2xl font-bold mb-1">Model Intelligence</h1>
      <p className="text-xs text-[#6B7280] mb-4 font-mono-num">Live forecast accuracy & historical backtesting</p>

      <Tabs defaultValue="accuracy" className="w-full">
        <TabsList className="bg-[#111827] border border-white/10 w-full grid grid-cols-2 h-auto p-1 rounded-xl mb-4">
          <TabsTrigger value="accuracy" data-testid="ml-tab-accuracy"
            className="text-xs data-[state=active]:bg-[#F59E0B] data-[state=active]:text-black rounded-lg py-1.5">
            Live Accuracy
          </TabsTrigger>
          <TabsTrigger value="backtest" data-testid="ml-tab-backtest"
            className="text-xs data-[state=active]:bg-[#F59E0B] data-[state=active]:text-black rounded-lg py-1.5">
            Backtest
          </TabsTrigger>
        </TabsList>
        <TabsContent value="accuracy">
          <AccuracyPage refreshKey={refreshKey} embedded />
        </TabsContent>
        <TabsContent value="backtest">
          <BacktestPage />
        </TabsContent>
      </Tabs>
    </div>
  );
}
